import { LOGIN_AXIOS } from "../config";

export const apiLoginUser = async data => {
    let form = new FormData();
    form.append("mcid", data.mcid)
    form.append("email", data.email);
    form.append("password", data.password);
    form.append("deviceName", data.deviceName);
    form.append("deviceid", data.deviceid);
    form.append("appID", data.appID);

    try {
        const response = await LOGIN_AXIOS().request({
            method: "POST",
            data: form
        });
        
        if (Array.isArray(response.data)) {
            return response.data[0];
        } else {
            return response.data;
        }
        
    } catch (error) {
        throw error;
    }
};
